import React, { useEffect, useState, useMemo } from "react";
import { filter } from "lodash";
import { Table, Input, Button, Modal, DatePicker } from "antd";
import { useNavigate } from "react-router";

import moment from "moment";
import dayjs from "dayjs";
import { useSelector, useDispatch } from "react-redux";
import {
  //getLeadExecutiveNotes,
  getLeadExecutiveRemarks,
} from "../../actionCreator/leadListingActionCreater";
import {
  getLeadRemarksDetails,
  submitLeadRemarks,
  resetSubmitLeadRemarkss,
} from "../../actionCreator/leadDetailsActionCreator";
import { Badge, Calendar } from "antd";

const CalenderModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showCal, setShowCal] = useState(false);
  const [payloadData, setPayloadData] = useState({});
  const notesFilterList = useSelector(
    (state) => state.leadListingReducer.leadExecutiveNotes,
  );
  const remarksFilterList = useSelector(
    (state) => state.leadListingReducer.leadExecutiveRemarks,
  );
  const leadRemarksDetails = useSelector(
    (state) => state.LeadDetailsReducer.leadRemarksDetails,
  );
  const saveleadRemarks = useSelector(
    (state) => state.LeadDetailsReducer.saveleadRemarks,
  );
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    if (leadRemarksDetails?.interactionDate) {
      setSelectedDate(dayjs(leadRemarksDetails.interactionDate));
    } else {
      setSelectedDate(null);
    }
  }, [leadRemarksDetails]);

  useMemo(() => {
    //dispatch(getLeadExecutiveNotes());
    dispatch(getLeadExecutiveRemarks());
  }, []);

  useEffect(() => {
    if (Object.keys(saveleadRemarks).length) {
      //saveleadRemarks
      //console.log(saveleadRemarks,'saveleadRemarks')
      dispatch(resetSubmitLeadRemarkss());
      setShowCal(false);
    }
  }, [saveleadRemarks]);

  const showTaskDetails = (id) => {
    setShowCal(!showCal);
    dispatch(getLeadRemarksDetails(id));
  };
  const viewLeadsData = (id) => {
    navigate("/lead-details/" + id);
  };

  const closeTaskModal = () => {
    setShowCal(false);
  };

  //console.log(notesFilterList,'notesFilterListnotesFilterList')
  const monthCellRender = (value) => {
    //const num = getMonthData(value);
    //const filteredData = filter(notesFilterList, (p) => p.lastUpdated ? moment(p.lastUpdated).utc().format('YYYY-MM')=== dayjs(value).format('YYYY-MM'):"");
    const filteredData = filter(remarksFilterList, (p) =>
      p.interactionDate
        ? moment(p.interactionDate).format("YYYY-MM") ===
          dayjs(value).format("YYYY-MM")
        : "",
    );
    // return num ? (
    //   <div className="notes-month">
    //     <section>{num}</section>
    //     <span>Backlog number</span>
    //   </div>
    // ) : null;

    return (
      <ul className="events">
        {filteredData.map((item) => (
          <li key={item.id} onClick={() => showTaskDetails(item.id)}>
            <Badge
              status="success"
              text={item.title ? item.title : item.remarks}
            />
          </li>
        ))}
        {/* {filteredData.map((item) => (
          <li key={item.id}>
            <Badge status="success" text={item.notefor}/>
          </li>
        ))} */}
      </ul>
    );
  };
  const getMonthData = (value) => {
    if (value.month() === 8) {
      return 1394;
    }
  };
  const dateCellRender = (value) => {
    //const filteredData = filter(notesFilterList, (p) => p.lastUpdated ? moment(p.lastUpdated).utc().format('YYYY-MM')=== dayjs(value).format('YYYY-MM'):"");
    const filteredData = filter(remarksFilterList, (p) =>
      p.interactionDate
        ? moment(p.interactionDate).format("YYYY-MM-DD") ===
          dayjs(value).format("YYYY-MM-DD")
        : "",
    );
    //const listData = getListData(value);notefor

    return (
      <ul className="events">
        {filteredData.map((item) => (
          <li key={item.id} onClick={() => showTaskDetails(item.id)}>
            <Badge
              status="success"
              text={item.title ? item.title : item.remarks}
            />
          </li>
        ))}
        {/* {filteredData.map((item) => (
          <li key={item.id}>
            <Badge status="success" text={item.notefor}/>
          </li>
        ))} */}
      </ul>
    );
  };
  const cellRender = (current, info) => {
    if (info.type === "date") return dateCellRender(current);
    if (info.type === "month") return monthCellRender(current);
    return info.originNode;
  };

  const onPanelChange = (date, dateString) => {
    //console.log(date, dateString);
  };

  const onConfrimCalenderModal = async () => {
    const payload = payloadData;
    //console.log("completed",payload);
    if (payload?.interactionDate) {
      await dispatch(submitLeadRemarks(payload));
      await dispatch(getLeadExecutiveRemarks());
    }
  };

  const onOk = async (value) => {
    //console.log("onOk: ", value);
    let payload = leadRemarksDetails;
    const newDate = new Date(value);
    const formattedDate = newDate.toISOString();
    payload.interactionDate = formattedDate;
    payload.update = true;
    setPayloadData(payload);
    //console.log(payload, "update remarks");
    //await dispatch(submitLeadRemarks(payload));
    //await dispatch(getLeadExecutiveRemarks());
  };
  return (
    <>
      <div id="taskcalender">
        <Calendar onPanelChange={onPanelChange} cellRender={cellRender} />
      </div>
      {showCal && (
        <Modal
          title={null}
          width="500px"
          closable={true}
          open={showCal}
          onCancel={closeTaskModal}
          footer={null}
          className="delete-popup"
          centered
        >
          <div className="tw-bg-slate-50 tw-text-slate-800 tw-text-lg tw-font-bold tw-py-4 tw-px-6 tw-rounded-t-2xl tw-border tw-border-solid tw-border-slate-100/50">
            Task Details
          </div>
          <div className="tw-p-6 tw-flex tw-flex-col tw-gap-4">
            <div className="tw-flex tw-items-center">
              <span className="tw-w-1/3 tw-text-xs tw-font-bold tw-text-slate-500 tw-uppercase tw-tracking-wider">Remarks</span>
              <span className="tw-w-2/3 tw-text-sm tw-text-slate-700 tw-font-medium">{leadRemarksDetails?.remarks}</span>
            </div>
            <div className="tw-flex tw-items-center">
              <span className="tw-w-1/3 tw-text-xs tw-font-bold tw-text-slate-500 tw-uppercase tw-tracking-wider">Task Status</span>
              <span className="tw-w-2/3 tw-text-sm tw-text-slate-700 tw-font-medium">Open</span>
            </div>
            <div className="tw-flex tw-items-center">
              <span className="tw-w-1/3 tw-text-xs tw-font-bold tw-text-slate-500 tw-uppercase tw-tracking-wider">Reschedule Date</span>
              <div className="tw-w-2/3">
                <DatePicker
                  format="YYYY-MM-DD HH:mm"
                  showTime={{
                    format: "HH:mm",
                  }}
                  value={selectedDate}
                  className="tw-w-full !tw-h-[40px] !tw-rounded-xl !tw-border-slate-200 hover:!tw-border-slate-400 focus:!tw-border-theme"
                  onChange={(val) => {
                    setSelectedDate(val);
                    if (val) {
                      let payload = { ...leadRemarksDetails };
                      const formattedDate = val.toDate ? val.toDate().toISOString() : new Date(val).toISOString();
                      payload.interactionDate = formattedDate;
                      payload.update = true;
                      setPayloadData(payload);
                    }
                  }}
                  onOk={onOk}
                />
              </div>
            </div>
          </div>
          <div className="tw-flex tw-bg-slate-50 tw-rounded-b-2xl tw-py-4 tw-px-6 tw-items-center tw-justify-end tw-gap-3 tw-border tw-border-solid tw-border-slate-100/50">
            <Button
              className="!tw-h-[38px] !tw-rounded-lg !tw-border-slate-200 !tw-bg-white !tw-px-5 !tw-text-xs !tw-font-bold !tw-text-slate-500 hover:!tw-border-slate-300 hover:!tw-text-slate-700 tw-transition-all tw-duration-200"
              onClick={closeTaskModal}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              className="!tw-h-[38px] !tw-rounded-lg !tw-bg-theme !tw-border-theme !tw-text-white tw-text-xs tw-font-bold tw-px-5 tw-shadow-sm hover:tw-shadow-md tw-transition-all tw-duration-200"
              onClick={onConfrimCalenderModal}
            >
              Save
            </Button>
            <Button
              type="primary"
              className="!tw-h-[38px] !tw-rounded-lg !tw-bg-emerald-600 !tw-border-emerald-600 !tw-text-white tw-text-xs tw-font-bold tw-px-5 tw-shadow-sm hover:tw-shadow-md tw-transition-all tw-duration-200"
              onClick={() => viewLeadsData(leadRemarksDetails?.lead?.id)}
            >
              View Lead
            </Button>
          </div>
        </Modal>
      )}
    </>
  );
};
export default CalenderModal;
